import React from 'react';

const ConversionPlanBanner = ({ character, currentLevel }) => {
  const plan = character?.conversionPlan;
  if (!plan?.recommendations?.[currentLevel]) return null;

  const rec = plan.recommendations[currentLevel];
  const targetLevel = plan.targetLevel;
  const progress = currentLevel - 1;
  const total = targetLevel - 1;

  return (
    <div className="rounded-lg border border-cyan-500/30 bg-cyan-900/10 p-3 mb-4">
      <div className="flex items-center justify-between mb-1">
        <span className="text-xs font-medium text-cyan-300">
          Brewmaster Suggestion (Level {currentLevel} of {targetLevel})
        </span>
        <span className="text-xs text-gray-500">
          {progress}/{total} level-ups
        </span>
      </div>
      <p className="text-sm text-gray-300">{rec.reasoning}</p>
      {rec.domainCard?.reasoning && (
        <p className="text-xs text-gray-400 mt-1">
          Domain card: {rec.domainCard.reasoning}
        </p>
      )}
    </div>
  );
};

export default ConversionPlanBanner;
